import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { showError, showSuccess } from "ReduxErrorBar";
import { Row, Col, Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { DropdownButton, Dropdown } from "react-bootstrap";
import Pagination from "react-js-pagination";
import _ from "lodash";
import {
  screenHeightLeftFromTop,
  itemCount,
  COMMON_FAIL_MESSAGE,
} from "Constants";
import LocaleStrings from "Languages";
import { APPUSER_NOT_LOGIN_USERSCOUNT } from "DashboardActions";
import {
  analyticsViewList,
  fetchNotLogUserCount,
  sendBulkWelcomeMail,
  sendWelcomeMail,
} from "DashboardUserAction";

class UserList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: null,
      activeLoader: false,
      pageNumber: 1,
      selectedUsers: [],
      allCheck: false,
      actionOption: false,
    };
  }

  close() {
    this.props.analyticsViewList({ showModal: false });
  }

  renderUserList(moreaction) {
    var selectedUsers = this.state.selectedUsers;
    let list = this.props.usernotLoginCount.userList;
    if (this.props.viewAnalyticsData?.key == "DASHBOARD_ATTENDEES") {
      list = this.props.dashboardTotalAttendees;
    }
    return _.map(list, (appUser) => {
      var index = _.findIndex(selectedUsers, function (curuser) {
        return curuser.appuserid === appUser.appuserid;
      });

      var checked = false;
      if (index >= 0) {
        checked = true;
      }
      return (
        <tr>
          {moreaction ? (
            <td>
              <label
                className="custom-container-checkbox"
                style={{ marginTop: -1 }}>
                <input
                  type="checkbox"
                  onChange={() => this.updateSelectedUser(appUser)}
                  checked={checked}
                />
                <span className="checkmark" />
              </label>
            </td>
          ) : (
            ""
          )}
          <td>{appUser.firstname + " " + appUser.lastname}</td>
          <td>{appUser.email}</td>
          {moreaction ? (
            <td>
              <div className={`action-button`}>
                <Button
                  className="btn btn-custom-table-blue"
                  loading={
                    appUser.appuserid == this.state.loading ? true : false
                  }
                  type="button"
                  onClick={(e) =>
                    appUser.isactive == 1 ? this.sendMail(e, appUser) : null
                  }
                  disabled={appUser.isactive == 1 ? false : true}>
                  {LocaleStrings.button_send_welcome_email}
                </Button>
              </div>
            </td>
          ) : (
            ""
          )}
        </tr>
      );
    });
  }

  updateSelectedUser = (user) => {
    var selectedUsers = this.state.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      if (!user.deleted) {
        var newSelectUser = { ...user, checked: true };
        selectedUsers = [...selectedUsers, newSelectUser];
      }

      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  selectAllUsers = () => {
    var state = this.state.allCheck;
    var selectedUsers = this.state.selectedUsers;
    var allUsers = this.props.usernotLoginCount.userList;
    var newSelectUser = [];
    var newSelectedUsers = [];
    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user that add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }

        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.appuserid !== user.appuserid;
        });
        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  checkMatchArray = (selectedUsers) => {
    setTimeout(() => {
      var userList = this.props.usernotLoginCount.userList;

      var newArray = [];
      _.map(userList, (appUser) => {
        var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === appUser.appuserid;
        });

        if (newSelectedUsers && newSelectedUsers.length > 0) {
          // newArray = [...newArray, newSelectedUsers];
          newArray.push(newSelectedUsers[0]);
        }
      });

      // Check for current page selection and according to show or hide action option for bulk email send
      if (newArray.length > 0) {
        this.setState({ actionOption: true });
      } else {
        this.setState({ actionOption: false });
      }

      // Check for all user selected or not according to that check or uncheck master check option
      if (newArray.length > 0 && newArray.length === userList.length) {
        this.setState({ allCheck: true });
      } else {
        this.setState({ allCheck: false });
      }
    }, 100);
  };

  handleSelectAllUsers = () => {
    //console.log("totalUsernotLoginCount", this.props.totalUsernotLoginCount);
    let { totalUsernotLoginCount, usernotLoginCount } = this.props;
    let { selectedUsers } = this.state;
    let allUsers = totalUsernotLoginCount.userList;
    var newSelectedUsers = [];

    if (selectedUsers.length == usernotLoginCount.count) {
      allUsers.map((v) => {
        delete v["checked"];
      });

      this.checkMatchArray([]);
      this.setState({ selectedUsers: [] });
    } else {
      newSelectedUsers = allUsers.map((v) => ({ ...v, checked: true }));

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    }
  };

  paginationCallback = (pageNumber) => {
    this.props.fetchNotLogUserCount(
      this.props.session,
      pageNumber,
      0,
      (response) => {
        this.checkMatchArray(this.state.selectedUsers);
      }
    );

    this.setState({ ...this.state, pageNumber });
  };

  // Sent bulk emails
  sendBulkEmail = (key) => {
    let { session } = this.props;
    let { selectedUsers } = this.state;

    let users = [];

    selectedUsers.map((val, index) => {
      let obj = {
        username: val.username,
        eventid: session.eventid,
        logtype: "email",
        playerid: null,
        emailid: val.email,
        logstatus: "pending",
        createdbyid: session.userid,
      };

      if (val.isactive == 1 && val.userwaitlistmode == 0) {
        obj.content = "Welcome confirmed email";
        obj.userstatus = "confirmed";
      } else if (val.userwaitlistmode == 1) {
        obj.content = "Welcome waitlist email";
        obj.userstatus = "waitlist";
      }

      users.push(obj);
    });

    if (users.length > 0) {
      this.setState({ activeLoader: true });
      this.props.sendBulkWelcomeMail(session, users, (response) => {
        this.setState({ activeLoader: false });
        if (response.success === 1) {
          this.clearAllData();
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else {
          this.clearAllData();
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      });
    } else {
      this.props.showError(
        LocaleStrings.user_validation_message_welcome_email_sent
      );
    }
  };

  sendMail = (e, appUser) => {
    e.preventDefault();
    var email = appUser.email;
    this.setState({ loading: appUser.appuserid });
    this.props.sendWelcomeMail(
      this.props.session,
      { email: email },
      (response) => {
        this.setState({ loading: null });
        if (response.success === 1) {
          this.props.showSuccess(LocaleStrings.user_message_welcome_email_sent);
        } else if (response.success === 3) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error1
          );
        } else if (response.success === 4) {
          this.props.showSuccess(
            LocaleStrings.user_message_welcome_email_error2
          );
        } else {
          this.props.showError(COMMON_FAIL_MESSAGE);
        }
      }
    );
  };

  clearAllData = (e) => {
    this.setState({
      selectedUsers: [],
      allCheck: false,
      actionOption: false,
    });
  };

  render() {
    var {
      session,
      viewAnalyticsData,
      deviceSize,
      usernotLoginCount,
      totalUsernotLoginCount,
    } = this.props;
    let { selectedUsers, allCheck, actionOption, pageNumber } = this.state;
    let moreaction = false;
    if (
      viewAnalyticsData &&
      viewAnalyticsData.key == APPUSER_NOT_LOGIN_USERSCOUNT
    ) {
      moreaction = true;
    }
    let itemCount = 10;
    const mapObj = {
      startnum: pageNumber === 1 ? 1 : itemCount * (pageNumber - 1) + 1,
      endnum:
        usernotLoginCount.count > itemCount * pageNumber
          ? itemCount * pageNumber
          : usernotLoginCount.count,
      totalnum: usernotLoginCount.count,
    };

    return (
      <div>
        <Modal
          className="modal-container"
          show={
            viewAnalyticsData && viewAnalyticsData.showModal === true
              ? true
              : false
          }
          onHide={this.close}
          animation={true}
          keyboard={false}
          backdrop="static"
          dialogClassName="modal-md">
          <Modal.Header>
            <div className="import-modal-title">
              {viewAnalyticsData && viewAnalyticsData.title
                ? viewAnalyticsData.title
                : ""}
            </div>
            <button
              type="button"
              className="i-custom-cross-popup pull-right"
              onClick={() => this.close()}>
              <img
                className="i-custom-small"
                src="../../style/images/custom-icons/cross-black.png"
              />
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className={this.state.activeLoader ? "user_main_div" : ""}>
              {viewAnalyticsData &&
              viewAnalyticsData.key != "DASHBOARD_ATTENDEES" ? (
                <div className="header-buttons vertical-align-center-justify-between">
                  <div className="h-100 vertical-align-center">
                    <ul className="select-all-checkbox-section">
                      <li>
                        <label className="custom-container-checkbox">
                          <input
                            type="checkbox"
                            onChange={this.selectAllUsers}
                            checked={allCheck}
                          />
                          <span className="checkmark" />
                        </label>
                      </li>
                      <li>
                        <span style={{ fontWeight: "bold", marginRight: 15 }}>
                          {LocaleStrings.user_option_select_all}
                        </span>
                      </li>
                      <li>
                        <div className="dropdown-btn-container ml-2">
                          {actionOption === true ? (
                            <DropdownButton
                              className="dropdown-blue-carret-btn"
                              title=""
                              key="1"
                              id="dropdown-basic-2"
                              // bsSize="xsmall"
                              nocaret="true">
                              <Dropdown.Item
                                eventKey="email_selected_confirmed"
                                onClick={() =>
                                  this.sendBulkEmail("email_selected_confirmed")
                                }>
                                {LocaleStrings.button_send_welcome_email}
                              </Dropdown.Item>
                            </DropdownButton>
                          ) : (
                            ""
                          )}
                        </div>
                      </li>
                    </ul>
                    {selectedUsers.length > 0 ? (
                      <div className="ml-10">
                        {usernotLoginCount.count == selectedUsers.length ? (
                          <span>
                            {_.replace(
                              LocaleStrings.user_text_all_users_selected,
                              "#total",
                              usernotLoginCount.count
                            )}
                          </span>
                        ) : (
                          <span>
                            {_.replace(
                              LocaleStrings.user_text_total_selected_user,
                              "#total",
                              selectedUsers.length
                            )}
                          </span>
                        )}

                        <span
                          className="text-primary cursor-pointer ml-10"
                          onClick={this.handleSelectAllUsers}>
                          {usernotLoginCount.count == selectedUsers.length
                            ? LocaleStrings.user_text_clear_all_selected_users
                            : _.replace(
                                LocaleStrings.user_text_select_all_usera,
                                "#total",
                                usernotLoginCount.count
                              )}
                        </span>
                      </div>
                    ) : null}
                  </div>
                  <div className="h-100 vertical-align-center">
                    <div className="user-counting-per-page">
                      {LocaleStrings.user_counting_per_page.replace(
                        /startnum|endnum|totalnum/gi,
                        (matched) => mapObj[matched]
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  {LocaleStrings.total_loggedin_usercount}{" "}
                  {this.props.dashboardTotalAttendees.length}
                </div>
              )}

              <div
                className="scrollable-content pt-0"
                style={{
                  height: deviceSize.height - (screenHeightLeftFromTop + 50),
                }}>
                <div className="main-table-container">
                  <table className="table">
                    <thead>
                      <tr>
                        {moreaction ? <th>#</th> : ""}
                        <th>{LocaleStrings.user}</th>
                        <th>{LocaleStrings.email}</th>
                        {moreaction ? (
                          <th>{LocaleStrings.user_table_list_action}</th>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>

                    <tbody className="tbody-background">
                      {this.renderUserList(moreaction)}
                    </tbody>
                  </table>

                  {viewAnalyticsData &&
                  viewAnalyticsData.key != "DASHBOARD_ATTENDEES" &&
                  usernotLoginCount &&
                  usernotLoginCount.count > itemCount ? (
                    <div className="">
                      <Pagination
                        activePage={this.state.pageNumber}
                        itemsCountPerPage={itemCount}
                        totalItemsCount={usernotLoginCount.count}
                        pageRangeDisplayed={itemCount}
                        onChange={this.paginationCallback}
                        style={{ float: "right" }}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </Modal.Body>
          {/* <Modal.Footer></Modal.Footer> */}
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    viewAnalyticsData: state.viewAnalyticsData,
    usernotLoginCount: state.usernotLoginCount,
    totalUsernotLoginCount: state.totalUsernotLoginCount,
    dashboardTotalAttendees:
      state.dashboardTotalAttendees &&
      state.dashboardTotalAttendees.userList &&
      state.dashboardTotalAttendees.userList.length > 0
        ? state.dashboardTotalAttendees.userList
        : [],
  };
}
export default connect(mapStateToProps, {
  analyticsViewList,
  fetchNotLogUserCount,
  sendBulkWelcomeMail,
  sendWelcomeMail,
})(UserList);
